<template>
  <div class="home">
    <van-loading class="home-loadings" v-show="show" type="spinner" color="#1989fa" />
    <div v-if="!show" class="home-promotion">
      <!--个人信息-->
      <div class="home-promotion-name">
        <img :src="list.avatar" alt />
        <div>
          <p>
            <span>{{list.phone}}</span>
            <img src alt />
            <!-- <img src="../../assets/image/edit.png" alt /> -->
          </p>
          <span v-if="list.level=='业务员'">{{list.level}}</span>
          <span v-if="list.level=='会员'">{{list.level}}</span>
          <span v-if="list.level=='商家'">
            <i></i>
            {{list.level}}
          </span>
        </div>
        <img @click="personal(list.level)" src="../../assets/image/set up.png" alt />
      </div>
      <div class="home-promotion-add">
        <div class="home-promotion-total">
          <div class="home-promotion-one">
            <div @click="Returns(1)">
              <p>{{  Math.floor((list.total/1000)  * 100) / 100}}</p>
              <p >
                累计收益(元) &nbsp;
                &gt;
              </p>
              <p>含待结算{{   Math.floor((list.unsettled/1000)  * 100) / 100}}元</p>
            </div>
            <div  @click="Returns(2)">
              <p>{{  Math.floor((list.withdrawal/1000)  * 100) / 100}}</p>
              <p>
                累计提现(元) &nbsp;
                &gt;
              </p>
            </div>
          </div>
          <div class="home-promotion-tow">
            <p>
              可提现金额:
              <span>{{   Math.floor((list.balance/1000)  * 100) / 100}}</span>
            </p>
            <van-button @click="deposits" type="primary" color="#FFC000" size="small">立即提现 &gt;</van-button>
          </div>
        </div>
        <div class="home-promotion-adj">
          <div @click="client(1)">
            <p>{{list.subordinate_business}}</p>
            <p >下级商户 &gt;</p>
          </div>
          <div @click="client(2)">
            <p>{{list.subordinate_user}}</p>
            <p >下级客户 &gt;</p> 
          </div>
        </div>
      </div>
      <div class="home-promotion-clean">
        <div @click="generalize" class="home-promotion-back">
          <p>推广赚钱</p>
          <p>分享二维码给好友，好友付钱你得佣金</p>
        </div>
        <div v-if="list.level=='商家'" class="home-promotion-backone">
          <!-- <div  class="home-promotion-backone"> -->
          <p>查看订单明细</p>
          <p>锁定客户，客户付钱商家得返利</p>
          <van-button @click="check" type="primary" size="small">立即查看</van-button>
        </div>
        <div v-else class="home-promotion-backone home-promotion-backones">
          <!-- <div  class="home-promotion-backone home-promotion-backones"> -->
          <p>我是商家，申请入驻</p>
          <p>锁定客户，客户付钱商家得返利</p>
          <van-button @click="immediately" type="primary" size="small">立即申请</van-button>
        </div>
        <div class="home-promotion-backtow">
          <p>关注微信公众号“开三汇”，随时查看我的收益</p>
          <img src="@/assets/image/lADP.jpg" alt />
          <!-- <img src="../../assets/image/" alt /> -->
          <p>保存二维码到手机</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { personInfo } from "../../api/promotion/promotion";
import { getUserToken } from "@/utils/Cookie";

// import store from "@/store/index";
import { request } from "@/utils/https";
export default {
  name: "promotions",
  data() {
    return {
      types: "", //是否是商家还是个人中心
      list: [],
      show: true,
      merchant_no: "",
      merchant_name: "",
      level: ''
    };
  },
  methods: {
    Returns(id) {
      if (id == 1) {
        if (parseInt(this.list.total) != 0) {
          this.$router.push({
            path: "Returns",
            query: { types: id }
          });
        }
      }
      if (id == 2) {
        if (parseInt(this.list.withdrawal) != 0) {
          this.$router.push({
            path: "Returns",
            query: { types: id }
          });
        }
      }
    },
    deposits() {
      this.$router.push({
        path: "deposit",
        query: { types: this.$route.query.types }
      });
    },
    personal(id) {
      console.log(id);
      this.$router.push({
        path: "Personal",
        query: { level: this.level }
      });
    },
    // ssss() {
    //   console.log(this.list, this.show, 222222);
    // },
    async DistributionLists() {
      // var xhr = null;
      //       if (window.XMLHttpRequest) {
      //           xhr = new XMLHttpRequest();
      //       } else {
      //           xhr = new ActiveXObject("Microsoft.XMLHTTP");
      //       }
      // xhr.onreadystatechange = () => {
      //   if (xhr.readyState === 4) {
      //     if (xhr.status === 200) {
      //       // console.log("成功，响应的文本内容为" + xhr.responseText);

      //       let res = JSON.parse(xhr.responseText);
      //       console.log(res, "个人中心信息");
      //       if (res.data) {
      //         console.log(res.data, 1111111111111);
      //         this.list = res.data;
      //         this.show = false;
      //         console.log(this.list, this.show, 222222);
      //       }
      //     } else {
      //       console.log("出错" + xhr.status);
      //     }
      //   }
      // };
      // xhr.open(
      //   "POST",
      //   store.state.baseURL + "user/person/personInfo?token=" + getUserToken(),
      //   true
      // );
      // xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      // xhr.send();

      // personInfo().then(res => {  //个人中心信息请求接口
      //   // console.log(res, "个人中心信息");
      //   if (res.data) {
      //     this.list = res.data;
      //     this.show = false;
      //   }
      // });
      let res = await request("user/person/personInfo?token=" + getUserToken());
      console.log(res, "-=");
      if (res.data) {
        this.list = res.data;
        this.level = res.data.level;
        this.show = false;
        if (this.list.merchant_no) {
          this.merchant_no = this.list.merchant_no;
          this.merchant_name = this.list.merchant_name;
        }
      }
    },
    immediately() {
      this.$router.push({
        path: "merchant"
        // query: { types: this.type, name: this.name }
      });
    },
    check() {
      this.$router.push({
        path: "indent",
        query: {
          merchant_no: this.merchant_no,
          merchant_name: this.merchant_name
        }
      });
    },
    client(id) {
      if (id == 1) {
        if (parseInt(this.list.subordinate_business) != 0) {
          this.$router.push({
            path: "subordinate",
            query: { types: id }
          });
        }
      }
      if (id == 2) {
        if (parseInt(this.list.subordinate_user) != 0) {
          this.$router.push({
            path: "subordinate",
            query: { types: id }
          });
        }
      }
    },
    generalize() {
      this.$router.push({
        //跳转个人设置页
        path: "generalize",
        query: { nickname: this.list.nickname, avatar: this.list.avatar }
      });
    }
  },
  created() {},
  mounted() {
    this.DistributionLists();
  }
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  background: rgba(246, 247, 249, 1);

  .home-promotion {
    .home-promotion-name {
      //   height: 6.84375rem;
      overflow: hidden;
      background-color: #fff;
      padding: 1.25rem 1.015625rem 1.21875rem 0.875rem;

      img:first-child {
        float: left;
        width: 4.375rem;
        height: 4.375rem;
        border-radius: 50%;
        border: 0.125rem solid rgba(242, 242, 242, 1);
      }
      div:nth-child(2) {
        float: left;
        padding: 0.375rem 0 0.3125rem 0.5rem;
        p:first-child {
          font-size: 1.15rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(3, 3, 3, 1);
          padding-bottom: 0.5rem;
          img {
            width: 0.875rem;
            height: 0.84375rem;
            margin: 0;
            padding: 0.25625rem;
          }
        }
        span:last-child {
          display: inline-block;
          padding: 0.09375rem 0.46875rem;
          background: rgba(255, 249, 222, 1);
          border-radius: 8px;
          font-size: 0.875rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 189, 27, 1);
          overflow: hidden;
          i {
            margin-top: 0.21875rem;
            display: inline-block;
            width: 1.1rem;
            height: 1.1rem;
            float: none;
            background: linear-gradient(
              360deg,
              rgba(178, 151, 77, 1) 0%,
              rgba(255, 222, 103, 1) 100%
            );
            background: url("../../assets/image/lA.jpg");
            background-size: 100% 100%;
          }
        }
      }
      img:last-child {
        float: right;
        width: 1.5rem;
        height: 1.5rem;
        padding: 1.46875rem 0.265625rem 1.471875rem;
      }
    }
    .home-promotion-add {
      padding: 0.03125rem 0.75rem 0.625rem 0.75rem;
      background: linear-gradient(
        360deg,
        rgba(231, 240, 255, 1) 0%,
        rgba(255, 255, 255, 1) 100%
      );

      .home-promotion-total {
        background: linear-gradient(
          90deg,
          rgba(39, 113, 255, 1) 0%,
          rgba(60, 127, 255, 1) 100%
        );
        border-radius: 0.25rem;
        .home-promotion-one {
          overflow: hidden;
          padding: 0.9375rem 2.46875rem 1rem 2.46875rem;
          div {
            float: left;
            p:first-child {
              font-size: 1.4375rem;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: rgba(255, 255, 255, 1);
              margin-bottom: 0.25rem;
            }
            p:last-child,
            p:nth-child(2) {
              font-size: 0.8125rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
            }
          }
          div:last-child {
            float: right;
          }
        }
        .home-promotion-tow {
          overflow: hidden;
          padding: 0.46875rem 0.90625rem 0.46875rem 0.75rem;
          background: linear-gradient(90deg, #508bffff 0%, #3c7fffff 100%);
          //   border-radius: 0px 0px 0px 8px;

          p {
            margin-top: 0.28125rem;
            float: left;
            font-size: 0.9375rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
          }
          button {
            float: right;
            border-radius: 8px;
            font-size: 0.9375rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
      .home-promotion-adj {
        margin-top: 0.625rem;
        overflow: hidden;
        background: #fff;
        border-radius: 0.25rem;
        padding: 0.71875rem 0.625rem 0.6875rem 0.625rem;
        div {
          width: 50%;
          float: left;
          text-align: center;
          p:first-child {
            font-size: 1.125rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(41, 114, 255, 1);
            margin-bottom: 0.25rem;
          }
          p:last-child {
            font-size: 0.8125rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
          }
        }
      }
    }
    .home-promotion-clean {
      background-color: #fff;
      padding: 0.85rem 0.75rem 1.09375rem 0.75rem;
      .home-promotion-back {
        height: 4rem;
        background: url("../../assets/image/extension.png");
        background-size: 100% 100%;
        p:first-child {
          padding: 1rem 0.84375rem 0.15625rem 1.09375rem;
          font-size: 1.125rem;
          font-family: FZLTDHK--GBK1-0, FZLTDHK--GBK1;
          font-weight: normal;
          color: rgba(255, 255, 255, 1);
          text-shadow: 0px 3px 15px rgba(255, 166, 0, 1);
        }
        p:last-child {
          font-size: 0.8125rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(255, 255, 255, 1);
          padding: 0 0.84375rem 0 1.09375rem;
          text-shadow: 0px 3px 15px rgb(236, 146, 19);
        }
      }
      .home-promotion-backone {
        margin-top: 0.75rem;
        height: 4.375rem;
        background: url("../../assets/image/apply.png");
        background-size: 100% 100%;
        position: relative;
        p:first-child {
          padding: 0.84375rem 0.84375rem 0.15625rem 1.09375rem;
          font-size: 1.125rem;
          font-family: FZLTDHK--GBK1-0, FZLTDHK--GBK1;
          font-weight: normal;
          color: rgba(51, 51, 51, 1);
        }
        p:nth-child(2) {
          font-size: 0.8125rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(102, 102, 102, 1);
          padding: 0 0.84375rem 0 1.09375rem;
        }
        button {
          position: absolute;
          right: 0.90625rem;
          top: 1.75rem;
          background: linear-gradient(
            90deg,
            rgba(65, 146, 255, 1) 0%,
            rgba(59, 109, 255, 1) 100%
          );
        }
      }
      .home-promotion-backones {
        margin-top: 0.75rem;
        height: 4.375rem;
        background: url("../../assets/image/see.png");
        background-size: 100% 100%;
        position: relative;
      }
      .home-promotion-backtow {
        padding: 1.25rem 2.0625rem 0 2.0625rem;
        text-align: center;
        img {
          width: 8.25rem;
          height: 8.25rem;
        }
      }
    }
  }
}
</style>
